export default __webpack_public_path__ + "static/media/sun-logo-color.f3ff62e5.png";